import { isEffectArray, getType } from '@/common/utils';

/* 关联类型 (CateRefType)枚举 */
export const CATEREFTYPEENUM = {
  0: {
    key: 0,
    name: '自营+POP',
    postval: 0,
  },
  1: {
    key: 1,
    name: '自营',
    postval: 1,
  },
  2: {
    key: 2,
    name: 'POP',
    postval: 2,
  },
};

/* 推荐范围【4个固定关联事业群】枚举 */
export const DEPTIDENUM = [
  {
    key: 1420,
    name: '3c家电事业群',
    postval: 1420,
  },
  {
    key: 1727,
    name: '大商超全渠道事业群',
    postval: 1727,
  },
  {
    key: 1726,
    name: '时尚居家事业群',
    postval: 1726,
  },
  {
    key: 3531,
    name: '生活服务事业群',
    postval: 3531,
  },
];

/* 品类筛选关联范围 (CidScopeType)枚举 */
export const CIDSCOPEENUM = {
  0: {
    key: 0,
    name: '全部',
    postval: 0,
  },
  1: {
    key: 1,
    name: '相同"一级品类"',
    postval: 1,
  },
  2: {
    key: 2,
    name: '不同"一级品类"',
    postval: 2,
  },
};

/* 数据请求接口的上报 */
export const REPORT_CONST = {
  CODE: `cross_category_card`,
  SETOP: 1,
  GETOP: 2,
};

/* 排序字段 */
export const SORTFIELDENUM = {
  REF: {
    key: 'REF',
    dis: '关联度',
    frontKey: 'refScorePer', //品类关联度评分
  },
  PERM: {
    key: 'PERM',
    dis: '品类渗透',
    frontKey: 'permScorePer', //品类渗透空间评分
  },
  PROM: {
    key: 'PROM',
    dis: '推荐值',
    frontKey: 'promScorePer', //综合推荐分
  },
};

/* 排序类型 */
export const SORTORDERENUM = {
  1: {
    key: 1,
    dis: '正序',
    frontTips: 'ascend',
  },
  2: {
    key: 2,
    dis: '倒序',
    frontTips: 'descend',
  },
};

/* 用户引导键 */
export const USERGUIDEKEY = 'kpl';

/**********工具************/
/* 过滤掉非有效的字段【为空的或者空数组、空对象的字段】 */
export function cutNullOptions(options) {
  if (!options) return {};

  if (getType(options) === 'object') {
    const computedOptions = Object.keys(options).reduce((pre, cur) => {
      if ((options[cur] ?? '') !== '') {
        // 只取有效的数组
        if (getType(options[cur]) === 'array') {
          if (isEffectArray(options[cur])) {
            pre[cur] = options[cur];
          }
        } else if (getType(options[cur]) === 'object') {
          // 只取有效的对象
          if (Object.keys(options[cur]).length > 0) {
            pre[cur] = options[cur];
          }
        } else {
          pre[cur] = options[cur];
        }
      }
      return pre;
    }, {});
    return computedOptions;
  }

  return {};
}
